/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_Toggle_MarketingInputs */

const en_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing emails`)
};

const de_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing-E-Mails`)
};

const fr_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mails marketing`)
};

const es_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correos de marketing`)
};

const it_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail di marketing`)
};

const nl_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing-e-mails`)
};

const pl_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-maile marketingowe`)
};

const fi_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markkinointisahkopostit`)
};

const da_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing-e-mails`)
};

const sv_consent_settings_toggle_marketing = /** @type {(inputs: Consent_Settings_Toggle_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marknadsforingsmejl`)
};

/**
* | output |
* | --- |
* | "Marketing emails" |
*
* @param {Consent_Settings_Toggle_MarketingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_toggle_marketing = /** @type {((inputs?: Consent_Settings_Toggle_MarketingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_Toggle_MarketingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_toggle_marketing(inputs)
	if (locale === "fr") return fr_consent_settings_toggle_marketing(inputs)
	if (locale === "es") return es_consent_settings_toggle_marketing(inputs)
	if (locale === "it") return it_consent_settings_toggle_marketing(inputs)
	if (locale === "nl") return nl_consent_settings_toggle_marketing(inputs)
	if (locale === "pl") return pl_consent_settings_toggle_marketing(inputs)
	if (locale === "fi") return fi_consent_settings_toggle_marketing(inputs)
	if (locale === "da") return da_consent_settings_toggle_marketing(inputs)
	if (locale === "sv") return sv_consent_settings_toggle_marketing(inputs)
	return en_consent_settings_toggle_marketing(inputs)
});